<template>
  <div class="view">
    <div class="content">
      <h2 class="ui inverted header">Reset password</h2>
      <sui-segment :loading="loading">
        <sui-form :error="hasError" @submit.prevent="submit">
          <sui-form-field>
            <sui-input type="text" ref="email" v-model.trim="email" placeholder="Email" icon="user" icon-position="left" autocomplete="email" required />
          </sui-form-field>
          <sui-button size="large" color="blue" fluid>Reset</sui-button>
          <div class="reset">
            Remember your password? <router-link :to="{path: '/user/login', query: {email}}" data-goal="USER_SIGNIN_OPEN">Log in</router-link>
          </div>
          <sui-message error>
            {{error}}
          </sui-message>
        </sui-form>
      </sui-segment>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import utils from '@/utils'
  
  export default {
    name: 'AccountRecovery',
    data() {
      return {
        email: '',
        loading: false,
        error: null,
      }
    },
    computed: {
      hasError() {
        return Boolean(this.error)
      }
    },
    methods: {
      submit() {
        this.loading = true
        this.error = null
        utils.reachGoal('USER_RESET_REQUEST')
        api.recovery(this.email).then(() => {
          this.$router.push('/user/recoveryStart')
        }).catch(error => {
          this.error = error
        }).finally(() => {
          this.loading = false
        })
      }
    },
    mounted() {
      this.email = this.$route.query.email
      this.$nextTick(() => {
        this.$refs.email.$refs.input.focus()
      })
    },
  }
</script>

<style scoped>
  .view { display: flex; align-items: center; justify-content: center; text-align: center; }
  .content { min-width: 300px; }
  .reset { margin-top: .5em; color: #999; }
</style>
